import * as React from 'react'
function SvgBookmark(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 4C9.8 4 8 5.8 8 8v24.764a2 2 0 002.894 1.789L20 30l9.106 4.553A2 2 0 0032 32.763V8c0-2.2-1.8-4-4-4H12z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgBookmark
